import React from "react";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import Box from "@material-ui/core/Box";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import Container from "@material-ui/core/Container";
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import logo from "assets/images/logo.png";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withRouter } from "react-router";
import { message } from "constants/message";

import { 
  Button, 
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";
import {
  Group,
} from "@material-ui/icons";
import Copyright from "../../Components/Copyright";
import useAuth from "Hooks/Upload/useAuth";
import useApi from "Hooks/Upload/useApi";

import UploadLogout from "../../Components/UploadLogout";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  toolbar: {
    paddingRight: 24,
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  userName: {
    display: "inherit",
    alignItems: "center",
    fontSize: "15px",
  },
  appBar: {
    position: "fixed",
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  title: {
    flexGrow: 1,
  },
  logoImage: {
    width: "140px" ,
    cursor: "pointer",
  },
  drawerPaper: {
    position: "fixed",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflow: "hidden",
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
  },
  container: {
    [theme.breakpoints.down('xl')]: {
      maxWidth: "1285px",
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: "95%",
    },
    paddingLeft: drawerWidth,
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  containerShift: {
    paddingLeft: theme.spacing(7),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  loading: {
    position: "fixed",
    zIndex: 111111,
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#000",
    opacity: 0.3,
  },
  menuList: {
    height: "90%",
    overflowX: "hidden",
  },
  menuListClose: {
    height: "90%",
    overflow: "hidden",
  },
  hideMenu: {
    display: "flex",
    alignItems: "center",
    padding: "16px",
    cursor: "pointer",
  },
  menuIcon: {
    minWidth: "45px",
  }
}));

const LinkedListSubheader = withStyles(() => ({
  sticky: {
    cursor: "pointer",
  },
}))(ListSubheader);
const ActiveListSubheader = withStyles((theme) => ({
  sticky: {
    backgroundColor: theme.palette.primary.main,
    color: "#FFF",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
}))(ListSubheader);

function ListItemLink(props) {
  return <ListItem button component={Link} disabled={1 == props.isdisable} {...props} />;
}

function Layout(props) {
  const auth = useAuth();
  const api = useApi();
  const messages = message();

  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const [logoutOpen, setLogoutOpen] = React.useState(false);
  const [isShowErrorModal, setIsShowErrorModal] = React.useState(false);
  const [userName, setUserName] = React.useState("");

  React.useEffect(() => {
    const uploadToken = localStorage.getItem("uploadtoken");
    if (!uploadToken || uploadToken === null) {
      props.history.push("/upload/?status=401");
      return;
    }

    setUserName(JSON.parse(localStorage.getItem("uploaduser")).name);

    auth.login({
      token: uploadToken,
      user: JSON.parse(localStorage.getItem("uploaduser")),
    });

  }, []);

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleLogoutOpen = () => {
    setLogoutOpen(true);
  };

  const handleLogoutClose = () => {
    setLogoutOpen(false);
  };

  const handleClickLogo = () => {
    props.history.push("/upload/top");
  };

  return (
    <div className={classes.root}>
      {api.state.isFetch && (
        <div className={classes.loading}>
          <CircularProgress color="secondary" />
        </div>
      )}
      <UploadLogout logoutOpen={logoutOpen} handleLogoutClose={handleLogoutClose} />
      <CssBaseline />
      <AppBar
        position="absolute"
        className={classes.appBar}
      >
        <Toolbar className={classes.toolbar}>
          <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
            className={classes.title}
            onClick={handleClickLogo}
          >
            <img src={logo} className={classes.logoImage}/>
          </Typography>

          <Typography
            color="inherit"
            noWrap
            className={classes.userName}
          >
            <AccountCircleIcon /> {userName}
          </Typography>
          <Link to="/upload/config" style={{ color: "#FFF", textDecoration: "none" }}>
            <Button color="inherit">管理メニュー</Button>
          </Link>
          <Button color="inherit" onClick={() => handleLogoutOpen(true)}>
            ログアウト
          </Button>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        classes={{
          paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
        }}
        open={open}
      >
        <div className={classes.toolbarIcon}>
          <IconButton onClick={handleDrawerClose}>
            <ChevronLeftIcon />
          </IconButton>
        </div>
        <Divider />
        <List 
          id="menuList"
          className={open ? classes.menuList : classes.menuListClose}
        >
          {true && (
            <ListItemLink to="/upload/top">
              <ListItemIcon className={classes.menuIcon}>
                <Group />
              </ListItemIcon>
              <ListItemText primary="アカウント管理" />
            </ListItemLink>
          )}
        </List>
        <div 
          className={classes.hideMenu}
          onClick={open ? handleDrawerClose : handleDrawerOpen}
        >
          <ListItemIcon>
            {open ? (<ChevronLeftIcon />) : (<ChevronRightIcon />)}
          </ListItemIcon>
          <ListItemText primary="メニューを隠す" />
        </div>
      </Drawer>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container className={
          clsx(classes.container, !open && classes.containerShift)
        }>
          {props.content}
          <Box pt={4}>
            <Copyright />
          </Box>
        </Container>
      </main>
      <Dialog open={isShowErrorModal} 
        onClose={() => setIsShowErrorModal(false)}
      >
        <DialogContent>
          <DialogContentText>
            {messages.errorMsg.getManualErr}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={() => setIsShowErrorModal(false)}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default withRouter(Layout);
